<template>
  <el-tabs v-model="tabsIndex">
    <el-tab-pane label="合同管理" name="CompanyProject">
      <CompanyProject v-if="tabsIndex==='CompanyProject'" />
    </el-tab-pane>
    <el-tab-pane label="单位管理" name="CompanyProjectEnterprise">
      <ThirdPartyCooperativeEnterprise v-if="urge_type===3&&tabsIndex==='CompanyProjectEnterprise'" />
      <ThirdPartyLitigationCooperativeEnterprise v-if="urge_type===4&&tabsIndex==='CompanyProjectEnterprise'" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import ThirdPartyCooperativeEnterprise from "../thirdparty/ThirdPartyCooperativeEnterprise";
import ThirdPartyLitigationCooperativeEnterprise
  from "../thirdparty_litigation/ThirdPartyLitigationCooperativeEnterprise";
import CompanyProject from "./CompanyProject";
export default {
  name: "CooperativeLayout",
  components: {CompanyProject, ThirdPartyLitigationCooperativeEnterprise, ThirdPartyCooperativeEnterprise},
  props:{
    urge_type:{
      type:Number,
      default:3
    }
  },
  data(){
    return{
      tabsIndex:"CompanyProject"
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty_common/CooperativeLayout.vue